function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import theme, { type } from '../../styles/theme';
import { themify } from '../../styles/mixins';
import { withSpacing } from '../../lib/hoc/withSpacing';
const StyledHeading = styled.span.withConfig({
  displayName: "Heading__StyledHeading",
  componentId: "vnjspb-0"
})(["display:", ";text-align:", ";font-weight:", ";font-family:", ";letter-spacing:", ";line-height:", ";text-transform:", ";width:", ";color:", ";font-size:", ";vertical-align:", ";"], x => x.block ? 'block' : 'inline-block', x => x.textAlign, x => x.fontWeight, x => x.fontFamily, x => x.letterSpacing, x => x.lineHeight, x => x.uppercase ? 'uppercase' : 'none', x => x.block ? '100%' : 'auto', x => x.color, x => type.scale[x.fontSize], x => !x.block ? 'baseline' : 'inherit').withComponent((_ref) => {
  let {
    block,
    color,
    fontFamily,
    fontSize,
    fontWeight,
    heading,
    letterSpacing,
    lineHeight,
    textAlign,
    uppercase
  } = _ref,
      domProps = _objectWithoutProperties(_ref, ["block", "color", "fontFamily", "fontSize", "fontWeight", "heading", "letterSpacing", "lineHeight", "textAlign", "uppercase"]);

  return heading ? /*#__PURE__*/React.createElement(heading, domProps) : /*#__PURE__*/React.createElement("span", domProps);
});
export const Heading = (_ref2) => {
  let {
    block = true,
    children,
    color,
    fontWeight = 600,
    letterSpacing = theme.type.letterSpacingHeadings
  } = _ref2,
      props = _objectWithoutProperties(_ref2, ["block", "children", "color", "fontWeight", "letterSpacing"]);

  return /*#__PURE__*/React.createElement(StyledHeading, _extends({
    block: block,
    color: themify(color),
    letterSpacing: letterSpacing,
    fontWeight: fontWeight
  }, props), children);
};
export const HeroHeading = withSpacing((_ref3) => {
  let {
    children,
    fontSize = 1
  } = _ref3,
      props = _objectWithoutProperties(_ref3, ["children", "fontSize"]);

  return /*#__PURE__*/React.createElement(Heading, _extends({
    fontSize: fontSize
  }, props, {
    block: true
  }), children);
});
export const SectionHeading = withSpacing((_ref4) => {
  let {
    children,
    fontSize = 3
  } = _ref4,
      props = _objectWithoutProperties(_ref4, ["children", "fontSize"]);

  return /*#__PURE__*/React.createElement(Heading, _extends({
    fontSize: fontSize
  }, props, {
    block: true
  }), children);
});
export const SubHeading = withSpacing((_ref5) => {
  let {
    block,
    children,
    fontSize = 3,
    inline
  } = _ref5,
      props = _objectWithoutProperties(_ref5, ["block", "children", "fontSize", "inline"]);

  return /*#__PURE__*/React.createElement(Heading, _extends({
    block: inline ? false : block,
    fontSize: fontSize
  }, props), children);
});
export const TinyHeading = withSpacing((_ref6) => {
  let {
    block,
    children,
    fontSize = 6,
    inline
  } = _ref6,
      props = _objectWithoutProperties(_ref6, ["block", "children", "fontSize", "inline"]);

  return /*#__PURE__*/React.createElement(Heading, _extends({
    fontSize: fontSize,
    block: inline ? false : block
  }, props), children);
});
export default withSpacing(Heading);